import { Constant } from '@configs/index';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputDate, InputText, Radio } from '@molecules/Forms';
import { CloseFormType } from '@organisms/GenesisEs/Forms/CloseFormType';
import { Storage } from '@states/Storage';
import { Button, Form } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';
import * as yup from 'yup';
import { Tooltip } from '../Utils';

type Props = {
    submitHandler: any;
};

const schema = yup.object().shape({
    // contactId: yup.string().matches(/^(|[0-9]+)$/, '数字を入力してください'),
    powerCustomerLocationNumber: yup.string().matches(/^(|[0-9]{22})$/, '数字22桁で入力してください'),
});
const clearValues: CloseFormType = Constant.SEARCH_FORM_DATA.CLOSE_DEFAULT;
const descriptions = Constant.TOOLTIP_DESCRIPTIONS;

const CloseForm = (props: Props) => {
    const defaultValues: CloseFormType = Storage.get(Storage.keys.GENESISES_CLOSELIST);
    const { register, handleSubmit, clearErrors, reset, setValue, getValues, formState: { errors } } = useForm<CloseFormType>({ defaultValues, resolver: yupResolver(schema) });
    const onClear = () => {
        clearErrors();
        reset();
        setValue('requestCategory', clearValues.requestCategory);
        setValue('contactId', clearValues.contactId);
        setValue('powerCustomerLocationNumber', clearValues.powerCustomerLocationNumber);
        setValue('abolitionRequestDate', clearValues.abolitionRequestDate);
        setValue('abolitionDesiredDate', clearValues.abolitionDesiredDate);
        setValue('supplyEndDate', clearValues.supplyEndDate);
        setValue('demolitionDate', clearValues.demolitionDate);
        // setValue('acceptStatus', clearValues.acceptStatus);
        setValue('systemClass', clearValues.systemClass);
    };
    const onSubmit: SubmitHandler<CloseFormType> = (data: CloseFormType) => {
        data.timestamp = new Date().getTime();
        props.submitHandler(data);
        Storage.set(Storage.keys.GENESISES_CLOSELIST, data);
    };

    return (
        <FormWithStyled>
            <TableWithStyled className='searchTable'>
                <TBodyWithStyled>
                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>申込種別</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <Radio
                                register={register}
                                controlId='requestCategory'
                                data={Constant.REQUEST_CATEGORY}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>契約ID</LabelWithStyled>
                                <Tooltip description={descriptions.CONTACT_ID} idKey='ID' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputText
                                register={register}
                                controlId='contactId'
                                width='small'
                                error={errors.contactId}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>供給地点特定番号</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputText
                                register={register}
                                controlId='powerCustomerLocationNumber'
                                error={errors.powerCustomerLocationNumber}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>廃止依頼日</LabelWithStyled>
                                <Tooltip description={descriptions.REQUEST_DATE} idKey='REQUEST_DATE' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='abolitionRequestDate'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>廃止希望日</LabelWithStyled>
                                <Tooltip description={descriptions.ABOLITION_DESIRED_DATE} idKey='ABOLITION_DESIRED_DATE' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='abolitionDesiredDate'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>供給廃止日</LabelWithStyled>
                                <Tooltip description={descriptions.CLOSE_DATE} idKey='CLOSE_DATE' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='supplyEndDate'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>解体予定日</LabelWithStyled>
                                <Tooltip description={descriptions.DEMOLITION_DATE} idKey='DEMOLITION_DATE' />
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='demolitionDate'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>受付工程</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <Form.Group controlId="acceptStatus">
                                {Constant.ACCEPT_STATUS_FOR_FORM.map((item) => (
                                    <span key={`acceptStatus-${item.value}`}>
                                        <Form.Check
                                            inline
                                            value={item.value}
                                            type='checkbox'
                                            label={item.label}
                                            id={`acceptStatus-${item.value}`}
                                            {...register('acceptStatus')}
                                        />
                                        {item.label === '送信不要' ? <FormCheckToolTipWithStyled><Tooltip description={descriptions.ACCEPT_STATUS_NNTR} idKey='acceptStatus_NNTR' placement='bottom' /></FormCheckToolTipWithStyled> : ''}
                                    </span>
                                ))}
                            </Form.Group>
                        </BodyWithStyled>
                    </RowWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>システム</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <Radio
                                register={register}
                                controlId='systemClass'
                                data={Constant.SYSTEM_CLASS}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                    {/* <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>警告対応</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <Radio
                                register={register}
                                controlId='responseStatus'
                                data={Constant.RESPONSE_STATUS}
                            />
                        </BodyWithStyled>
                    </RowWithStyled> */}
                </TBodyWithStyled>
            </TableWithStyled>

            <ButtonsWithStyled>
                <Button variant='secondary' size='sm' onClick={onClear}>　クリア　</Button>{' '}
                <Button variant='primary' size='sm' onClick={handleSubmit(onSubmit)}>　検　索　</Button>
            </ButtonsWithStyled>

        </FormWithStyled>
    )
}


const FormWithStyled = styled.form`
    margin: 5px 5px 10px;
`
const TableWithStyled = styled.table`
`
const TBodyWithStyled = styled.tbody`
`
const RowWithStyled = styled.tr`
`
const HeadWithStyled = styled.th`
`
const BodyWithStyled = styled.td`
`
const LabelWithStyled = styled.span`
`
const FormCheckToolTipWithStyled = styled.span`
    position: relative;
    right: 16px;
`
const ButtonsWithStyled = styled.div`
    & button + button {
        margin-left:10px;
    }
`

export default CloseForm;